import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const LoginRoute = ({ component: Component, isAuthenticate, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthenticate) {
        return <Redirect to="/courses" />;
      } else {
        return <Component {...props} />;
      }
    }}
  />
);

const mapStateToProps = state => ({
  isAuthenticate: state.authentication.isAuthenticate
});

export default connect(mapStateToProps)(LoginRoute);
